import { render, staticRenderFns } from "./DeliveryReceipts.vue?vue&type=template&id=e63cd736&scoped=true&"
import script from "./DeliveryReceipts.vue?vue&type=script&lang=js&"
export * from "./DeliveryReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63cd736",
  null
  
)

export default component.exports